import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ProductCatalog() {
  const products = [{
    name: 'Oil Cleanser - Aceite limpiador.',
    benefit: 'Limpieza profunda sin resecar, Un aceite limpiador suave, que se desliza delicadamente sobre el rostro, eliminando eficazmente los residuos de maquillaje y las impurezas de la piel.',
    image: 'https://cdn.magicpatterns.com/uploads/1d41Yb9tELHWVRFyqDC69H/Aceite_limpiador_en_suspension.png',
    link: 'https://mall.riman.com/nicolcabello/products/52521?Concern=101,93&Line=133&SubCategory=1&Category=5'
  }, {
    name: 'Dermatology  - Creama  reafirmante.',
    benefit: 'Hidratación intensiva y reparadora, crema reafirmante que ayuda a mantener la piel firme y resistente.',
    image: 'https://cdn.magicpatterns.com/uploads/5MwkKahWSB24i3R42HjswH/Crema_dermatologica_y_hojas_frescas.png',
    link: 'https://mall.riman.com/nicolcabello/products/52509?Concern=101,103,87,93,94&Line=133&SubCategory=2&Category=5,9'
  }, {
    name: 'Calming Balance - Gel Calmante.',
    benefit: '-Reconforta y calma la piel, ayudando a reducir visiblemente el enrojecimiento.\n-Mantiene la piel hidratada hasta por 72 horas\n-Proporciona un efecto refrescante de acción inmediata, mientras los activos ayudan a reducir la inflamación y la irritación con el uso continuo',
    image: 'https://cdn.magicpatterns.com/uploads/8fW7uRoZJq5bysi6ByHeMM/Gel_calmante_en_armonia_floral.png',
    link: 'https://mall.riman.com/nicolcabello/products/52511?Concern=101,93&Line=133&SubCategory=3&Category=5'
  }, {
    name: 'Oil Mist - Bruma Hidratante.',
    benefit: 'Esta mezcla hidratante combina el poder de los aceites con la nutrición de las vitaminas para brindar una piel radiante y luminosa.',
    image: 'https://cdn.magicpatterns.com/uploads/qRESXjdZjWABkN6Ars2n7v/Bottellas_flotantes_con_aceite_bifasico.png',
    link: 'https://mall.riman.com/nicolcabello/products/52513?Concern=93&Line=133&SubCategory=3&Category=5,9'
  }, {
    name: 'Dermatology - Pack de Booster + Sérum.',
    benefit: 'Booster: Un potenciador hidratante que aplica capas de hidratación en la piel para una tez radiante y saludable. Sérum: Un sérum iluminador hidratante que proporciona una luminosidad radiante a la piel. Fortalece la barrera cutánea.',
    image: 'https://cdn.magicpatterns.com/uploads/6dhimyZRGq7Gh69awdLE9D/Productos_dermatologicos_en_un_fondo_etereo.png',
    link: 'https://mall.riman.com/nicolcabello/products/52505?Concern=93&Line=133&SubCategory=3&Category=5,9'
  }, {
    name: 'Aceite para cabello.',
    benefit: 'Este serum de aceite para el cabello está enriquecido con aceites que ayudan a suavizar el cabello dañado, dejándolo suave y brillante.\n-Hidrata el cabello, proporcionando un brillo sano.\n-Mejora la cutícula dañada del cabello.\n-Proporciona volumen por 24 horas.\n-Reduce el rompimiento y encrespamiento.\n-Proporciona protección contra el calor.',
    image: 'https://cdn.magicpatterns.com/uploads/5c37GNxL8p1A7ASa8Nmpdw/Captura_de_pantalla_2026-04-10_a_la(s)_2.21.38_a.m..png',
    link: 'https://mall.riman.com/nicolcabello/products/52529?Concern=118,119,95&Line=131&SubCategory=5&Category=6,9'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="productos" className="py-24 bg-white relative overflow-hidden" data-id="element-169" data-mp="1k310crw9ysjg">
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-brand-beige/30 to-transparent -z-10" data-id="element-170" data-mp="1k53zc1fenw0b" />
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-171" data-mp="258ql421vr2me">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-172" data-mp="25b3dl959kvdp">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4 text-shimmer" data-id="element-173" data-mp="1qi9k2jt5qeq1">
            Nuestra Colección ✨
          </h2>
          <p className="text-brand-charcoal/70" data-id="element-174" data-mp="2j8i6woyn1nay">
            Productos RIMAN seleccionados para transformar tu piel 🌸
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-175" data-mp="2ebhza9m54chq">
          {products.map((product, index) => <motion.div key={index} variants={itemVariants} className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-brand-beige/50 soft-glow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-176" data-mp="39jjw1ax7daps" data-mpi={index}>
              {/* Product Image */}
              <div className="aspect-square bg-brand-beige/20 relative flex items-center justify-center p-8 group-hover:bg-brand-beige/30 transition-colors overflow-hidden" data-id="element-177" data-mp="3o8q2njyde37p">
                {product.image ? <img src={product.image} alt={product.name} className="w-full h-full object-cover absolute inset-0" data-id="element-178" data-mp="11dzwpkl60yu" /> : <div className="w-32 h-48 bg-white rounded-lg shadow-sm flex items-center justify-center relative overflow-hidden soft-glow" data-id="element-179" data-mp="az27ig3aj2yf">
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-sage-light/10" data-id="element-180" data-mp="2crzx831rtff5" />
                    <Sparkles className="w-8 h-8 text-brand-gold/60" data-id="element-181" data-mp="24sv77hzuu4gl" />
                  </div>}
              </div>

              {/* Product Details */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-182" data-mp="2epq4jxke5yta">
                <h3 className="text-xl font-serif font-medium text-brand-charcoal mb-2" data-id="element-183" data-mp="2erb09qifznsq">
                  {product.name}
                </h3>
                <p className="text-sm text-brand-charcoal/70 font-light mb-4 flex-grow" data-id="element-184" data-mp="2nqftchb8ioxi">
                  {product.benefit}
                </p>
                <div className="flex flex-col gap-3 mt-auto pt-2" data-id="element-185" data-mp="2jokv5lolorny">
                  <a href={product.link} target="_blank" rel="noopener noreferrer" className="btn-sparkle w-full py-3 bg-brand-sage text-white rounded-full text-sm font-medium hover:bg-brand-sage-dark transition-colors soft-glow-hover text-center" data-id="element-186" data-mp="2xgr00bmazc83">
                    🛒 Comprar con descuento
                  </a>
                  <a href="https://chat.whatsapp.com/HxUSbD6ZhKp7KYqvvPD122?s=cl&p=i&ilr=1&amv=2" target="_blank" rel="noopener noreferrer" className="btn-sparkle w-full py-3 bg-transparent border border-brand-charcoal/20 text-brand-charcoal rounded-full text-sm font-medium hover:bg-brand-cream transition-colors text-center" data-id="element-187" data-mp="3m2f6lrlo9czd">
                    💬 Quiero asesoría
                  </a>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}